import React, { useEffect, useRef, useState } from "react";
import { apiCall } from "../../../../utils/axiosService";
import { API_URL } from "../../../../utils/apiRoutes";
import { apiResponse } from "../../../../utils/apiResponse";
import Loader from "../../../Loader/Loader";
import { Button, Col, Row, Table } from "react-bootstrap";
import { commonService } from "../../../../utils/commonService";
import downArrow from "../../../../Assets/Images/Header/downArrow.svg";
import moment from "moment";
import emailIcon from "../../../../Assets/Images/Email.svg";
import infoIcon from "../../../../Assets/Images/Action Icons/infoIcon..svg";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import WidgetDetailModal from "../../WidgetDetailModal";
import downloadIcon from "../../../../Assets/Images/Operation/downloadIcon.svg";
import { compName } from "../../../../utils/constant";

const DaywiseModal = ({
    closeModal,
    asOfDate,
    selectedDate,
    pickupDate,
    propertyDetail,
    fromHeatMap,
    dateRange,
    para,
    api,
}) => {
    const [loading, setLoading] = useState(false);
    const [dayWiseData, setDayWiseData] = useState(null);
    const totalRef = useRef();
    const [widgetModal, setWidgetModal] = useState(false);
    const closeWidgetModal = () => {
        setWidgetModal(false);
    };
    const widgetDetailRef = useRef();
    const countForPickupAdrDivision = useRef();
    const { snapshottitle, propertyCode, snapshotId } = useParams();
    const [pys, setpys] = useState("");
    const [pye, setpye] = useState("");
    const defaultAsOfDateFromRTK = useSelector(
        (store) => store.headerProperty.defaultAsOfDate
    );
    const getDayWiseData = async () => {
        setLoading(true);
        setpys("");
        setpye("");
        let dayWiseDataResponse = await apiCall(
            {
                method: "POST",
                url:
                    API_URL.BASE_API_URL.SnapShot +
                    API_URL.DAILY_SUMMARY.SINGLE_DATE_SUMMARY_DAY_WISE,
                body: {
                    AsOfDate: asOfDate ? moment(asOfDate).format("YYYY-MM-DD") : "",
                    startDate: dateRange?.startDate
                        ? commonService.getDateForNode(dateRange?.startDate)
                        : "",
                    endDate: dateRange?.endDate
                        ? commonService.getDateForNode(dateRange?.endDate)
                        : "",
                    // SelectedDate: selectedDate
                    //   ? moment(selectedDate).format("YYYY-MM-DD")
                    //   : "",
                    propertyCode: propertyDetail?.propertyCode,
                    PickUpDate: pickupDate ? moment(pickupDate).format("YYYY-MM-DD") : "",
                },
            },
            false
        );

        let response = apiResponse(false, dayWiseDataResponse);

        if (response?.isValidate) {
            let dataFromApi = response?.data?.data;

            setpys(response?.data?.data[0].paststartdate);
            setpye(response?.data?.data[0].pastenddate);
            let groupingJson = [];
            totalRef.current = {
                room: 0,
                lyRoom: 0,
                stlyRoom: 0,
                LOS: 0,
                pickupFrom: 0,
                pickupAdr: 0,
                adr: 0,
                lyAdr: 0,
                stlyAdr: 0,
                revenue: 0,
                lyRevenue: 0,
                stlyRevenue: 0,

            };
            countForPickupAdrDivision.current = 0;

            if (dataFromApi && dataFromApi.length > 0) {
                const Unique_MarketSegment = [
                    ...new Set(
                        dataFromApi.map(item => item.MarketSegment).filter(Boolean)
                    )
                ];

                if (Unique_MarketSegment && Unique_MarketSegment.length > 0) {
                    Unique_MarketSegment.map((MarketSegment) => {

                        let Data_MarketSegment = dataFromApi.filter((m) => m.MarketSegment === MarketSegment);
                        let obj_MarketSegment = {
                            "name": MarketSegment,
                            "guid": commonService.GenerateGUID(),
                            "room": 0,
                            "lyRoom": 0,
                            "stlyRoom": 0,
                            "arrDate": "",
                            "LOS": 30,
                            "pickupFrom": 0,
                            "pickupAdr": 0,
                            "adr": 0,
                            "lyAdr": 0,
                            "stlyAdr": 0,
                            "revenue": 0,
                            "lyRevenue": 0,
                            "stlyRevenue": 0,
                            "items": []
                        }

                        const Unique_RateCodeAndDescript = [
                            ...new Set(
                                Data_MarketSegment.map(item => item.RateCode + (item.RateCodeDescript && item.RateCodeDescript !== null ? " - " + item.RateCodeDescript : "")).filter(Boolean)
                            )
                        ];


                        if (Unique_RateCodeAndDescript && Unique_RateCodeAndDescript.length > 0) {
                            Unique_RateCodeAndDescript.map((RateCodeAndDescript) => {

                                let Data_RateCodeAndDescript = Data_MarketSegment.filter((rd) => rd.RateCode + (rd.RateCodeDescript && rd.RateCodeDescript !== null ? " - " + rd.RateCodeDescript : "") === RateCodeAndDescript);
                                let obj_RateCodeAndDescript = {
                                    "name": RateCodeAndDescript,
                                    "guid": commonService.GenerateGUID(),
                                    "room": 0,
                                    "lyRoom": 0,
                                    "stlyRoom": 0,
                                    "arrDate": "",
                                    "LOS": 30,
                                    "pickupFrom": 0,
                                    "pickupAdr": 0,
                                    "adr": 0,
                                    "lyAdr": 0,
                                    "stlyAdr": 0,
                                    "revenue": 0,
                                    "lyRevenue": 0,
                                    "stlyRevenue": 0,
                                    "items": []
                                }


                                const Unique_Company = [
                                    ...new Set(
                                        Data_RateCodeAndDescript.map(item => item.Company).filter(Boolean)
                                    )
                                ];

                                if (Unique_Company && Unique_Company.length > 0) {
                                    Unique_Company.map((Company) => {

                                        let Data_Company = Data_RateCodeAndDescript.filter((c) => c.Company === Company);
                                        let obj_Company = {
                                            "name": Company,
                                            "guid": commonService.GenerateGUID(),
                                            "room": 0,
                                            "lyRoom": 0,
                                            "stlyRoom": 0,
                                            "arrDate": "",
                                            "LOS": 0,
                                            "pickupFrom": 0,
                                            "pickupAdr": 0,
                                            "adr": 0,
                                            "lyAdr": 0,
                                            "stlyAdr": 0,
                                            "revenue": 0,
                                            "lyRevenue": 0,
                                            "stlyRevenue": 0,
                                            "items": []
                                        }

                                        Data_Company.map((cd) => {
                                            obj_Company.items.push({
                                                name: cd.GuestName,
                                                guid: commonService.GenerateGUID(),
                                                room: cd.CURRENT_ROOM ? parseInt(cd.CURRENT_ROOM) : 0,
                                                lyRoom: cd.LY_ROOM ? parseInt(cd.LY_ROOM) : 0,
                                                stlyRoom: cd.STLY_ROOM ? parseInt(cd.STLY_ROOM) : 0,
                                                arrDate: cd.ArrDate,
                                                LOS: cd.LOS ? parseInt(cd.LOS) : 0,
                                                pickupFrom: cd.PICKUP_FROM_ROOM ? parseInt(cd.PICKUP_FROM_ROOM) : 0,
                                                pickupAdr: cd.ADR_PICKUP ? parseInt(cd.ADR_PICKUP) : 0,

                                                adr: (cd.CURRENT_REVENUE ? parseInt(cd.CURRENT_REVENUE) : 0) / (cd.CURRENT_ROOM ? parseInt(cd.CURRENT_ROOM) : 0),
                                                lyAdr: (cd.LY_Revenue ? parseInt(cd.LY_Revenue) : 0) / (cd.LY_ROOM ? parseInt(cd.LY_ROOM) : 0),
                                                stlyAdr: (cd.STLY_REVENUE ? parseInt(cd.STLY_REVENUE) : 0) / (cd.STLY_ROOM ? parseInt(cd.STLY_ROOM) : 0),

                                                revenue: cd.CURRENT_REVENUE ? parseInt(cd.CURRENT_REVENUE) : 0,
                                                lyRevenue: cd.LY_Revenue ? parseInt(cd.LY_Revenue) : 0,
                                                stlyRevenue: cd.STLY_REVENUE ? parseInt(cd.STLY_REVENUE) : 0,
                                                items: []
                                            });
                                        })



                                        obj_Company.items.forEach(item => {
                                            obj_Company.room += item.room;
                                            obj_Company.lyRoom += item.lyRoom;
                                            obj_Company.stlyRoom += item.stlyRoom;


                                            obj_Company.pickupFrom += item.pickupFrom;
                                            obj_Company.pickupAdr += item.pickupAdr;

                                            obj_Company.revenue += item.revenue;
                                            obj_Company.lyRevenue += item.lyRevenue;
                                            obj_Company.stlyRevenue += item.stlyRevenue;

                                            obj_Company.adr = (obj_Company.revenue) / (obj_Company.room);
                                            obj_Company.lyAdr = (obj_Company.lyRevenue) / (obj_Company.lyRoom);
                                            obj_Company.stlyAdr = (obj_Company.stlyRevenue) / (obj_Company.stlyRoom);
                                        });

                                        obj_RateCodeAndDescript.items.push(obj_Company);

                                    });
                                }


                                obj_RateCodeAndDescript.items.forEach(item => {
                                    obj_RateCodeAndDescript.room += item.room;
                                    obj_RateCodeAndDescript.lyRoom += item.lyRoom;
                                    obj_RateCodeAndDescript.stlyRoom += item.stlyRoom;

                                    obj_RateCodeAndDescript.pickupFrom += item.pickupFrom;
                                    obj_RateCodeAndDescript.pickupAdr += item.pickupAdr;

                                    obj_RateCodeAndDescript.revenue += item.revenue;
                                    obj_RateCodeAndDescript.lyRevenue += item.lyRevenue;
                                    obj_RateCodeAndDescript.stlyRevenue += item.stlyRevenue;

                                    obj_RateCodeAndDescript.adr = (obj_RateCodeAndDescript.revenue) / (obj_RateCodeAndDescript.room);
                                    obj_RateCodeAndDescript.lyAdr = (obj_RateCodeAndDescript.lyRevenue) / (obj_RateCodeAndDescript.lyRoom);
                                    obj_RateCodeAndDescript.stlyAdr = (obj_RateCodeAndDescript.stlyRevenue) / (obj_RateCodeAndDescript.stlyRoom);
                                });

                                obj_MarketSegment.items.push(obj_RateCodeAndDescript);
                            });
                        }


                        obj_MarketSegment.items.forEach(item => {
                            obj_MarketSegment.room += item.room;
                            obj_MarketSegment.lyRoom += item.lyRoom;
                            obj_MarketSegment.stlyRoom += item.stlyRoom;

                            obj_MarketSegment.pickupFrom += item.pickupFrom;
                            obj_MarketSegment.pickupAdr += item.pickupAdr;


                            obj_MarketSegment.revenue += item.revenue;
                            obj_MarketSegment.lyRevenue += item.lyRevenue;
                            obj_MarketSegment.stlyRevenue += item.stlyRevenue;

                            obj_MarketSegment.adr = (obj_MarketSegment.revenue) / (obj_MarketSegment.room);
                            obj_MarketSegment.lyAdr = (obj_MarketSegment.lyRevenue) / (obj_MarketSegment.lyRoom);
                            obj_MarketSegment.stlyAdr = (obj_MarketSegment.stlyRevenue) / (obj_MarketSegment.stlyRoom);
                        });
                        groupingJson.push(obj_MarketSegment);


                        totalRef.current.room = groupingJson.reduce((sum, item) => sum + (item.room || 0), 0);
                        totalRef.current.lyRoom = groupingJson.reduce((sum, item) => sum + (item.lyRoom || 0), 0);
                        totalRef.current.stlyRoom = groupingJson.reduce((sum, item) => sum + (item.stlyRoom || 0), 0);
                        totalRef.current.LOS = groupingJson.reduce((sum, item) => sum + (item.LOS || 0), 0);
                        totalRef.current.pickupFrom = groupingJson.reduce((sum, item) => sum + (item.pickupFrom || 0), 0);
                        totalRef.current.pickupAdr = groupingJson.reduce((sum, item) => sum + (item.pickupAdr || 0), 0);


                        totalRef.current.revenue = groupingJson.reduce((sum, item) => sum + (item.revenue || 0), 0);
                        totalRef.current.lyRevenue = groupingJson.reduce((sum, item) => sum + (item.lyRevenue || 0), 0);
                        totalRef.current.stlyRevenue = groupingJson.reduce((sum, item) => sum + (item.stlyRevenue || 0), 0);


                        totalRef.current.adr = parseInt(totalRef.current.revenue / totalRef.current.room);
                        totalRef.current.lyadr = parseInt(totalRef.current.lyrevenue / totalRef.current.lyroom);
                        totalRef.current.stlyadr = parseInt(totalRef.current.stlyrevenue / totalRef.current.stlyroom);
                    });
                }
            }

            let jsonForPickupAdr = [...groupingJson];
            let totalMarketSegmentPickupAdr = 0,
                totalMarketSegment = 0;

            const marketSegmentPickupAdr = () => {
                let pickupAdrValue = 0,
                    totalRateCode = 0;
                for (let i = 0; i < jsonForPickupAdr?.length; i++) {
                    for (let j = 0; j < jsonForPickupAdr?.[i]?.items?.length; j++) {
                        pickupAdrValue =
                            pickupAdrValue +
                            (jsonForPickupAdr?.[i]?.items?.[j]?.pickupAdr
                                ? parseInt(jsonForPickupAdr?.[i]?.items?.[j]?.pickupAdr)
                                : 0);
                        if (
                            jsonForPickupAdr?.[i]?.items?.[j]?.pickupAdr &&
                            jsonForPickupAdr?.[i]?.items?.[j]?.pickupAdr !== "0"
                        ) {
                            totalRateCode = totalRateCode + 1;
                        }
                    }
                    jsonForPickupAdr[i].pickupAdr = pickupAdrValue
                        ? Math.round(pickupAdrValue / totalRateCode)
                        : 0;
                    if (pickupAdrValue) {
                        totalMarketSegmentPickupAdr =
                            totalMarketSegmentPickupAdr +
                            Math.round(pickupAdrValue / totalRateCode);
                        totalMarketSegment = totalMarketSegment + 1;
                    }
                    pickupAdrValue = 0;
                    totalRateCode = 0;
                }
                totalRef.current.pickupAdr = totalMarketSegmentPickupAdr
                    ? Math.round(totalMarketSegmentPickupAdr / totalMarketSegment)
                    : 0;
            };

            const rateCodePickupAdr = () => {
                let pickupAdrValue = 0,
                    totalCompany = 0;
                for (let i = 0; i < jsonForPickupAdr?.length; i++) {
                    for (let j = 0; j < jsonForPickupAdr?.[i]?.items?.length; j++) {
                        for (
                            let k = 0;
                            k < jsonForPickupAdr?.[i]?.items?.[j]?.items?.length;
                            k++
                        ) {
                            pickupAdrValue =
                                pickupAdrValue +
                                (jsonForPickupAdr?.[i]?.items?.[j]?.items?.[k]?.pickupAdr
                                    ? parseInt(
                                        jsonForPickupAdr?.[i]?.items?.[j]?.items?.[k]?.pickupAdr
                                    )
                                    : 0);
                            if (
                                jsonForPickupAdr?.[i]?.items?.[j]?.items?.[k]?.pickupAdr &&
                                jsonForPickupAdr?.[i]?.items?.[j]?.items?.[k]?.pickupAdr !== "0"
                            ) {
                                totalCompany = totalCompany + 1;
                            }
                        }
                        jsonForPickupAdr[i].items[j].pickupAdr = pickupAdrValue
                            ? Math.round(pickupAdrValue / totalCompany)
                            : 0;
                        pickupAdrValue = 0;
                        totalCompany = 0;
                    }
                }
            };

            const companyPickupAdr = () => {
                let pickupAdrValue = 0,
                    totalGuest = 0;
                for (let i = 0; i < jsonForPickupAdr?.length; i++) {
                    for (let j = 0; j < jsonForPickupAdr?.[i]?.items?.length; j++) {
                        for (
                            let k = 0;
                            k < jsonForPickupAdr?.[i]?.items?.[j]?.items?.length;
                            k++
                        ) {
                            for (
                                let l = 0;
                                l <
                                jsonForPickupAdr?.[i]?.items?.[j]?.items?.[k]?.items?.length;
                                l++
                            ) {
                                pickupAdrValue =
                                    pickupAdrValue +
                                    (jsonForPickupAdr?.[i]?.items?.[j]?.items?.[k]?.items?.[l]
                                        ?.pickupAdr
                                        ? parseInt(
                                            jsonForPickupAdr?.[i]?.items?.[j]?.items?.[k]?.items?.[
                                                l
                                            ]?.pickupAdr
                                        )
                                        : 0);
                                if (
                                    jsonForPickupAdr?.[i]?.items?.[j]?.items?.[k]?.items?.[l]
                                        ?.pickupAdr !== "0" &&
                                    jsonForPickupAdr?.[i]?.items?.[j]?.items?.[k]?.items?.[l]
                                        ?.pickupAdr
                                ) {
                                    totalGuest = totalGuest + 1;
                                }
                            }
                            jsonForPickupAdr[i].items[j].items[k].pickupAdr = pickupAdrValue
                                ? Math.round(pickupAdrValue / totalGuest)
                                : 0;
                            pickupAdrValue = 0;
                            totalGuest = 0;
                        }
                    }
                }
            };

            companyPickupAdr();
            rateCodePickupAdr();
            marketSegmentPickupAdr();

            setDayWiseData(jsonForPickupAdr);
            setLoading(false);
        }

        if (!response?.isValidate) {
            setDayWiseData(null);
            setLoading(false);
        }
    };
    const [tblids, settblids] = useState({
        daywisesummary: commonService.GenerateGUID(),
    });

    useEffect(() => {
        getDayWiseData();
    }, [selectedDate, dateRange]);

    const handleShowHideRow = (className, itemDetail) => {
        if (document.getElementById(className) !== null) {
            if (document.getElementById(className).classList.contains("active")) {
                document.getElementById(className).classList.remove("active");
            } else {
                document.getElementById(className).classList.add("active");
            }
        }

        const removeClass = (classNameDetail) => {
            const classList = document.getElementsByClassName(classNameDetail);
            for (let i = 0; i < classList?.length; i++) {
                if (classList[i].classList.contains("nestedTableRowNone")) {
                    classList[i].classList.remove("nestedTableRowNone");
                    classList[i].classList.add("singleDateSummmaryTr");
                } else {
                    classList[i].classList.add("nestedTableRowNone");
                    classList[i].classList.remove("singleDateSummmaryTr");
                }
            }
        };

        removeClass(className);

        const addChildClass = (childClassName) => {
            const classList = document.getElementsByClassName(childClassName);
            for (let i = 0; i < classList?.length; i++) {
                if (!classList[i].classList.contains("nestedTableRowNone")) {
                    classList[i].classList.add("nestedTableRowNone");
                    classList[i].classList.remove("singleDateSummmaryTr");
                }
            }
        };

        const removeAllClass = (childItems) => {
            for (let i = 0; i < childItems?.length; i++) {
                addChildClass(childItems[i]?.guid);

                if (
                    Array.isArray(childItems[i]?.items) &&
                    childItems[i]?.items?.length > 0
                ) {
                    removeAllClass(childItems[i]?.items);
                }
            }
        };

        if (Array.isArray(itemDetail?.items) && itemDetail?.items?.length > 0) {
            removeAllClass(itemDetail?.items);
        }
    };

    const checkActiveRow = (e, guid, itemDetail) => {
        if (e.currentTarget.classList.contains("active")) {
            e.currentTarget.classList.remove("active");
            e.currentTarget.classList.remove("singleDateSummmaryTr");
        } else {
            e.currentTarget.classList.add("active");
            e.currentTarget.classList.add("singleDateSummmaryTr");
        }
    };

    return (
        <div className="widget-container" style={{ position: "relative" }}>
            <Row>
                <Col>
                    {" "}
                    {api !== 0 && (
                        <div className="gap-1 widget-container-menu">
                            <Button
                                className="heading-menu-btns"
                                type="button"
                                title="Send Mail"
                            >
                                <img id={commonService.generateGlobalClickTrackerID("DaywiseModal", "emailicon", propertyCode)}
                                    src={emailIcon}
                                    alt="emailIcon"
                                    onClick={() => {
                                        commonService.fnSendWidgetMail(
                                            tblids.daywisesummary,
                                            "Day Wise Summary",
                                            snapshotId,
                                            defaultAsOfDateFromRTK,
                                            "",
                                            para?.widgetId
                                        );
                                    }}
                                />
                            </Button>
                            <Button className="heading-menu-btns" type="button">
                                <img id={commonService.generateGlobalClickTrackerID("DaywiseModal", "info", propertyCode)}
                                    src={infoIcon}
                                    alt="info"
                                    onClick={() => {
                                        widgetDetailRef.current = {
                                            widgetdetails: "",
                                            usernote: "",
                                            compName: compName?.ninetyDayOutlook,
                                            widgetId: para?.widgetId,
                                        };
                                        setWidgetModal(true);
                                    }}
                                />
                            </Button>
                            <Button className="heading-menu-btns" type="button">
                                <img id={commonService.generateGlobalClickTrackerID("DaywiseModal", "menuicon", propertyCode)}
                                    src={downloadIcon}
                                    alt="menuIcon"
                                    import={tblids.daywisesummary}
                                    onClick={() => {
                                        commonService.fnExportInCSV(
                                            tblids.daywisesummary,
                                            // "90 Days Outlook"
                                            `${propertyDetail?.propertyCode
                                            }-Day Wise Summary-${moment(new Date()).format(
                                                "MMDDYYYY"
                                            )}`
                                        );
                                    }}
                                />
                            </Button>
                        </div>
                    )}{" "}
                </Col>
            </Row>

            <Row>
                <Col md={12}>
                    {" "}
                    <div
                        className={`GroupNameModalMain ToolsSingleTicketPopUpMain singleDateSummaryModalMain no-box-shadow`}
                    >
                        <div className="GroupNameModalHeader">
                            <h2>
                                {`Day Wise Summary (${commonService.getDateInFormat(
                                    dateRange?.startDate
                                )} - ${commonService.getDateInFormat(
                                    dateRange?.endDate
                                )})`}{" "}
                                {pys &&
                                    pye &&
                                    `LY (${pys && commonService.getDateInFormat(pys)} - ${pye && commonService.getDateInFormat(pye)
                                    })`}{" "}
                            </h2>
                        </div>
                        <div className="mt-2">
                            <div className="ViewPropertySetupTable">
                                <div className="table__container">
                                    <div className="stripped__table">
                                        <Table id={tblids.daywisesummary} responsive>
                                            <thead>
                                                <tr>
                                                    <th className="border_right">Market Segment</th>
                                                    <th className="text-center">Room</th>
                                                    <th className="text-center">LY</th>
                                                    <th className="border_right text-center">STLY</th>
                                                    <th>Arr Date</th>
                                                    <th className="text-center">LOS</th>
                                                    <th className="text-center">Pickup From</th>
                                                    <th className="border_right text-end">ADR Pickup</th>
                                                    <th className="text-end">ADR</th>
                                                    <th className=" text-end">LY</th>
                                                    <th className="border_right text-end">STLY</th>
                                                    <th className="text-end">Revenue</th>
                                                    <th className="text-end">LY</th>
                                                    <th className="text-end">STLY</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {loading ? (
                                                    <tr style={{ height: "80px", position: "relative" }}>
                                                        <Loader />
                                                    </tr>
                                                ) : (
                                                    dayWiseData &&
                                                    dayWiseData?.map((item, index) => {
                                                        return (
                                                            <>
                                                                <tr id={item?.guid} className="shadowOnHover">
                                                                    <td className="border_right">
                                                                        <div id={commonService.generateGlobalClickTrackerID("DaywiseModal", "market-segment", item)}
                                                                            className={`d-flex gap-2`}
                                                                            onClick={() => {
                                                                                const classList =
                                                                                    document.getElementsByClassName(
                                                                                        item?.guid
                                                                                    );

                                                                                if (
                                                                                    classList[0].classList.contains(
                                                                                        "nestedTableRowNone"
                                                                                    )
                                                                                ) {
                                                                                    handleShowHideRow(item?.guid);
                                                                                } else {
                                                                                    handleShowHideRow(item?.guid, item);
                                                                                }
                                                                            }}
                                                                        >
                                                                            <p>{item?.name}</p>
                                                                            <img src={downArrow} />
                                                                        </div>
                                                                    </td>
                                                                    <td className="text-center">
                                                                        {commonService.formateRoom(item?.room)}
                                                                    </td>
                                                                    <td className="text-center">
                                                                        {commonService.formateRoom(item?.lyRoom)}
                                                                    </td>
                                                                    <td className="border_right text-center">
                                                                        {commonService.formateRoom(item?.stlyRoom)}
                                                                    </td>
                                                                    <td>
                                                                        {item?.arrDate
                                                                            ? commonService.getDateInFormat(
                                                                                item?.arrDate
                                                                            )
                                                                            : ""}
                                                                    </td>
                                                                    <td></td>
                                                                    <td className="text-center">
                                                                        {item?.pickupFrom}
                                                                    </td>
                                                                    <td className="border_right text-end">
                                                                        {commonService.formateAmount(
                                                                            item?.pickupAdr
                                                                        )}
                                                                    </td>
                                                                    <td className="text-end">
                                                                        {commonService.formateAmount(item?.adr)}
                                                                    </td>
                                                                    <td className="text-end ">
                                                                        {commonService.formateAmount(item?.lyAdr)}
                                                                    </td>
                                                                    <td className="text-end border_right">
                                                                        {commonService.formateAmount(item?.stlyAdr)}
                                                                    </td>
                                                                    <td className="text-end">
                                                                        {commonService.formateAmount(item?.revenue)}
                                                                    </td>
                                                                    <td className="text-end">
                                                                        {commonService.formateAmount(
                                                                            item?.lyRevenue
                                                                        )}
                                                                    </td>
                                                                    <td className="text-end">
                                                                        {commonService.formateAmount(
                                                                            item?.stlyRevenue
                                                                        )}
                                                                    </td>
                                                                </tr>
                                                                {Array.isArray(item?.items) &&
                                                                    item?.items?.length > 0 &&
                                                                    item?.items?.map(
                                                                        (rateCodeItem, rateCodeIndex) => (
                                                                            <>
                                                                                <tr
                                                                                    className={`${item?.guid} nestedTableRowNone shadowOnHover ratecode`}
                                                                                    id={rateCodeItem?.guid}
                                                                                >
                                                                                    <td className="border_right">
                                                                                        <div id={commonService.generateGlobalClickTrackerID("DaywiseModal", "market-segment", item)}
                                                                                            style={{ paddingLeft: "10px" }}
                                                                                            className="d-flex gap-2"
                                                                                            onClick={() => {
                                                                                                const classList =
                                                                                                    document.getElementsByClassName(
                                                                                                        rateCodeItem?.guid
                                                                                                    );

                                                                                                if (
                                                                                                    classList[0].classList.contains(
                                                                                                        "nestedTableRowNone"
                                                                                                    )
                                                                                                ) {
                                                                                                    handleShowHideRow(
                                                                                                        rateCodeItem?.guid
                                                                                                    );
                                                                                                } else {
                                                                                                    handleShowHideRow(
                                                                                                        rateCodeItem?.guid,
                                                                                                        rateCodeItem
                                                                                                    );
                                                                                                }
                                                                                            }}
                                                                                        >
                                                                                            <p>{rateCodeItem?.name}</p>
                                                                                            <img src={downArrow} />
                                                                                        </div>
                                                                                    </td>
                                                                                    <td className="text-center">
                                                                                        {commonService.formateRoom(
                                                                                            rateCodeItem?.room
                                                                                        )}
                                                                                    </td>
                                                                                    <td className=" text-center">
                                                                                        {commonService.formateRoom(
                                                                                            rateCodeItem?.lyRoom
                                                                                        )}
                                                                                    </td>
                                                                                    <td className="border_right text-center">
                                                                                        {commonService.formateRoom(
                                                                                            rateCodeItem?.stlyRoom
                                                                                        )}
                                                                                    </td>
                                                                                    <td>
                                                                                        {rateCodeItem?.arrDate
                                                                                            ? commonService.getDateInFormat(
                                                                                                rateCodeItem?.arrDate
                                                                                            )
                                                                                            : ""}
                                                                                    </td>
                                                                                    <td></td>
                                                                                    <td className="text-center">
                                                                                        {rateCodeItem?.pickupFrom}
                                                                                    </td>
                                                                                    <td className="border_right text-end">
                                                                                        {commonService.formateAmount(
                                                                                            rateCodeItem?.pickupAdr
                                                                                        )}
                                                                                    </td>
                                                                                    <td className="text-end">
                                                                                        {commonService.formateAmount(
                                                                                            rateCodeItem?.adr
                                                                                        )}
                                                                                    </td>
                                                                                    <td className="text-end ">
                                                                                        {commonService.formateAmount(
                                                                                            rateCodeItem?.lyAdr
                                                                                        )}
                                                                                    </td>
                                                                                    <td className="text-end border_right">
                                                                                        {commonService.formateAmount(
                                                                                            rateCodeItem?.stlyAdr
                                                                                        )}
                                                                                    </td>
                                                                                    <td className="text-end">
                                                                                        {commonService.formateAmount(
                                                                                            rateCodeItem?.revenue
                                                                                        )}
                                                                                    </td>
                                                                                    <td className="text-end">
                                                                                        {commonService.formateAmount(
                                                                                            rateCodeItem?.lyRevenue
                                                                                        )}
                                                                                    </td>
                                                                                    <td className="text-end">
                                                                                        {commonService.formateAmount(
                                                                                            rateCodeItem?.stlyRevenue
                                                                                        )}
                                                                                    </td>
                                                                                </tr>
                                                                                {Array.isArray(rateCodeItem?.items) &&
                                                                                    rateCodeItem?.items?.length > 0 &&
                                                                                    rateCodeItem?.items?.map(
                                                                                        (companyItem, companyIndex) => (
                                                                                            <>
                                                                                                <tr
                                                                                                    className={`${rateCodeItem?.guid} nestedTableRowNone shadowOnHover company`}
                                                                                                    id={companyItem?.guid}
                                                                                                >
                                                                                                    <td className="border_right">
                                                                                                        <div id={commonService.generateGlobalClickTrackerID("DaywiseModal", "market-segment", item)}
                                                                                                            style={{
                                                                                                                paddingLeft: "20px",
                                                                                                            }}
                                                                                                            className="d-flex gap-2"
                                                                                                            onClick={() => {
                                                                                                                const classList =
                                                                                                                    document.getElementsByClassName(
                                                                                                                        companyItem?.guid
                                                                                                                    );

                                                                                                                if (
                                                                                                                    classList[0].classList.contains(
                                                                                                                        "nestedTableRowNone"
                                                                                                                    )
                                                                                                                ) {
                                                                                                                    handleShowHideRow(
                                                                                                                        companyItem?.guid
                                                                                                                    );
                                                                                                                } else {
                                                                                                                    handleShowHideRow(
                                                                                                                        companyItem?.guid,
                                                                                                                        companyItem
                                                                                                                    );
                                                                                                                }
                                                                                                            }}
                                                                                                        >
                                                                                                            <p>{companyItem?.name}</p>
                                                                                                            <img src={downArrow} />
                                                                                                        </div>
                                                                                                    </td>
                                                                                                    <td className="text-center">
                                                                                                        {commonService.formateRoom(
                                                                                                            companyItem?.room
                                                                                                        )}
                                                                                                    </td>
                                                                                                    <td className=" text-center">
                                                                                                        {commonService.formateRoom(
                                                                                                            companyItem?.lyRoom
                                                                                                        )}
                                                                                                    </td>
                                                                                                    <td className=" text-center border_right">
                                                                                                        {commonService.formateRoom(
                                                                                                            companyItem?.stlyRoom
                                                                                                        )}
                                                                                                    </td>
                                                                                                    <td>
                                                                                                        {companyItem?.arrDate
                                                                                                            ? commonService.getDateInFormat(
                                                                                                                companyItem?.arrDate
                                                                                                            )
                                                                                                            : ""}
                                                                                                    </td>
                                                                                                    <td></td>
                                                                                                    <td className="text-center">
                                                                                                        {companyItem?.pickupFrom}
                                                                                                    </td>
                                                                                                    <td className="border_right text-end">
                                                                                                        {commonService.formateAmount(
                                                                                                            companyItem?.pickupAdr
                                                                                                        )}
                                                                                                    </td>
                                                                                                    <td className="text-end">
                                                                                                        {commonService.formateAmount(
                                                                                                            companyItem?.adr
                                                                                                        )}
                                                                                                    </td>
                                                                                                    <td className="text-end ">
                                                                                                        {commonService.formateAmount(
                                                                                                            companyItem?.lyAdr
                                                                                                        )}
                                                                                                    </td>
                                                                                                    <td className="text-end border_right">
                                                                                                        {commonService.formateAmount(
                                                                                                            companyItem?.stlyAdr
                                                                                                        )}
                                                                                                    </td>
                                                                                                    <td className="text-end">
                                                                                                        {commonService.formateAmount(
                                                                                                            companyItem?.revenue
                                                                                                        )}
                                                                                                    </td>
                                                                                                    <td className="text-end">
                                                                                                        {commonService.formateAmount(
                                                                                                            companyItem?.lyRevenue
                                                                                                        )}
                                                                                                    </td>
                                                                                                    <td className="text-end">
                                                                                                        {commonService.formateAmount(
                                                                                                            companyItem?.stlyRevenue
                                                                                                        )}
                                                                                                    </td>
                                                                                                </tr>
                                                                                                {Array.isArray(
                                                                                                    companyItem?.items
                                                                                                ) &&
                                                                                                    companyItem?.items?.length >
                                                                                                    0 &&
                                                                                                    companyItem?.items?.map(
                                                                                                        (guestItem, guestIndex) => (
                                                                                                            <tr id={commonService.generateGlobalClickTrackerID("DaywiseModal", "tr-onclick", item)}
                                                                                                                className={`${companyItem?.guid} nestedTableRowNone shadowOnHover guestname`}
                                                                                                                onClick={(e) => {
                                                                                                                    checkActiveRow(e);
                                                                                                                }}
                                                                                                            >
                                                                                                                <td className="border_right">
                                                                                                                    <div
                                                                                                                        style={{
                                                                                                                            paddingLeft:
                                                                                                                                "30px",
                                                                                                                        }}
                                                                                                                        className="d-flex gap-2"
                                                                                                                    >
                                                                                                                        <p>
                                                                                                                            {guestItem?.name}
                                                                                                                        </p>
                                                                                                                    </div>
                                                                                                                </td>
                                                                                                                <td className="text-center">
                                                                                                                    {commonService.formateRoom(
                                                                                                                        guestItem?.room
                                                                                                                    )}
                                                                                                                </td>
                                                                                                                <td className=" text-center">
                                                                                                                    {commonService.formateRoom(
                                                                                                                        guestItem?.lyRoom
                                                                                                                    )}
                                                                                                                </td>
                                                                                                                <td className="border_right text-center">
                                                                                                                    {commonService.formateRoom(
                                                                                                                        guestItem?.stlyRoom
                                                                                                                    )}
                                                                                                                </td>
                                                                                                                <td>
                                                                                                                    {guestItem?.arrDate
                                                                                                                        ? commonService.getDateInFormat(
                                                                                                                            guestItem?.arrDate
                                                                                                                        )
                                                                                                                        : ""}
                                                                                                                </td>
                                                                                                                <td className="text-center">
                                                                                                                    {guestItem?.LOS}
                                                                                                                </td>
                                                                                                                <td className="text-center">
                                                                                                                    {
                                                                                                                        guestItem?.pickupFrom
                                                                                                                    }
                                                                                                                </td>
                                                                                                                <td className="border_right text-end">
                                                                                                                    {commonService.formateAmount(
                                                                                                                        guestItem?.pickupAdr
                                                                                                                    )}
                                                                                                                </td>
                                                                                                                <td className="text-end">
                                                                                                                    {guestItem?.adr
                                                                                                                        ? commonService.formateAmount(
                                                                                                                            guestItem?.adr
                                                                                                                        )
                                                                                                                        : commonService.formateAmount(
                                                                                                                            0
                                                                                                                        )}
                                                                                                                </td>
                                                                                                                <td className="text-end ">
                                                                                                                    {guestItem?.lyAdr
                                                                                                                        ? commonService.formateAmount(
                                                                                                                            guestItem?.lyAdr
                                                                                                                        )
                                                                                                                        : commonService.formateAmount(
                                                                                                                            0
                                                                                                                        )}
                                                                                                                </td>
                                                                                                                <td className="text-end border_right">
                                                                                                                    {guestItem?.stlyAdr
                                                                                                                        ? commonService.formateAmount(
                                                                                                                            guestItem?.stlyAdr
                                                                                                                        )
                                                                                                                        : commonService.formateAmount(
                                                                                                                            0
                                                                                                                        )}
                                                                                                                </td>
                                                                                                                <td className="text-end">
                                                                                                                    {commonService.formateAmount(
                                                                                                                        guestItem?.revenue
                                                                                                                    )}
                                                                                                                </td>
                                                                                                                <td className="text-end">
                                                                                                                    {commonService.formateAmount(
                                                                                                                        guestItem?.lyRevenue
                                                                                                                    )}
                                                                                                                </td>
                                                                                                                <td className="text-end">
                                                                                                                    {commonService.formateAmount(
                                                                                                                        guestItem?.stlyRevenue
                                                                                                                    )}
                                                                                                                </td>
                                                                                                            </tr>
                                                                                                        )
                                                                                                    )}
                                                                                            </>
                                                                                        )
                                                                                    )}
                                                                            </>
                                                                        )
                                                                    )}
                                                                {index === dayWiseData?.length - 1 && (
                                                                    <tr className="shadowOnHover">
                                                                        <td className="boldTd border_right">
                                                                            Total
                                                                        </td>
                                                                        <td className="boldTd text-center">
                                                                            {commonService.formateRoom(
                                                                                totalRef.current.room
                                                                            )}
                                                                        </td>
                                                                        <td className="boldTd text-center ">
                                                                            {commonService.formateRoom(
                                                                                totalRef.current.lyRoom
                                                                            )}
                                                                        </td>
                                                                        <td className="boldTd text-center border_right">
                                                                            {commonService.formateRoom(
                                                                                totalRef.current.stlyRoom
                                                                            )}
                                                                        </td>
                                                                        <td className="boldTd"></td>
                                                                        <td className="boldTd"></td>
                                                                        <td className="boldTd text-center">
                                                                            {totalRef.current.pickupFrom}
                                                                        </td>
                                                                        <td className="boldTd text-end border_right">
                                                                            {commonService.formateAmount(
                                                                                totalRef.current.pickupAdr
                                                                            )}
                                                                        </td>
                                                                        <td className="boldTd text-end">
                                                                            {totalRef.current.revenue > 0 &&
                                                                                totalRef.current.room > 0
                                                                                ? commonService.formateAmount(
                                                                                    Math.round(
                                                                                        totalRef.current.revenue /
                                                                                        totalRef.current.room
                                                                                    )
                                                                                )
                                                                                : commonService.formateAmount(0)}
                                                                        </td>
                                                                        <td className="boldTd text-end">
                                                                            {totalRef.current.lyRevenue > 0 &&
                                                                                totalRef.current.lyRoom > 0
                                                                                ? commonService.formateAmount(
                                                                                    Math.round(
                                                                                        totalRef.current.lyRevenue /
                                                                                        totalRef.current.lyRoom
                                                                                    )
                                                                                )
                                                                                : commonService.formateAmount(0)}
                                                                        </td>
                                                                        <td className="boldTd text-end border_right">
                                                                            {totalRef.current.stlyRevenue > 0 &&
                                                                                totalRef.current.stlyRoom > 0
                                                                                ? commonService.formateAmount(
                                                                                    Math.round(
                                                                                        totalRef.current.stlyRevenue /
                                                                                        totalRef.current.stlyRoom
                                                                                    )
                                                                                )
                                                                                : commonService.formateAmount(0)}
                                                                        </td>
                                                                        <td className="boldTd text-end">
                                                                            {commonService.formateAmount(
                                                                                totalRef.current.revenue
                                                                            )}
                                                                        </td>
                                                                        <td className="boldTd text-end">
                                                                            {commonService.formateAmount(
                                                                                totalRef.current.lyRevenue
                                                                            )}
                                                                        </td>
                                                                        <td className="boldTd text-end">
                                                                            {commonService.formateAmount(
                                                                                totalRef.current.stlyRevenue
                                                                            )}
                                                                        </td>
                                                                    </tr>
                                                                )}
                                                            </>
                                                        );
                                                    })
                                                )}
                                            </tbody>
                                        </Table>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {widgetModal && (
                            <WidgetDetailModal
                                showModal={widgetModal}
                                closeModal={closeWidgetModal}
                                data={widgetDetailRef.current}
                            />
                        )}
                    </div>
                </Col>
            </Row>
        </div>
    );
};

export default DaywiseModal;
